import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserLocationState {
  provinceCode: string | null;
}

const initialState: UserLocationState = {
  provinceCode: null,
};

const userLocationSlice = createSlice({
  name: 'userLocation',
  initialState,
  reducers: {
    // derived from contactPreferences response, not fetched independently
    setProvinceCode(state, action: PayloadAction<string | null>) {
      state.provinceCode = action.payload;
    },
  },
});

export const { setProvinceCode } = userLocationSlice.actions;

export default userLocationSlice.reducer;
